import {UserBO} from "./UserBO";
import {AuditService} from "../PA.Core/Security/AuditService";
import {AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {
    esWB_BusinessUnit,
    esWB_Customer,
    esWB_Dimension,
    esWB_Domain_Item,
    esWB_User_Group
} from "../PA.Core/PAdbSchema";

export class UserBOAudit {

    constructor() { }

    static async UserAuditBO(UserBO: UserBO): Promise<AuditService> {
        const self = UserBO
        const auditService = new AuditService(self.dbContext)

        auditService.setReference("User", self.drWB_User.cif.WB_AUTHUSR_ID)


        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        // User properties
        const userParams: IAuditField [] = [
                {fieldName: "AUTHUSR_NAME",      realName: "User Name", bAllMsg: true }, //create
                {fieldName: "AUTHUSR_ID",        realName: "User ID"  , bAllMsg: true },
                {fieldName: "AUTHUSR_FIRSTNAME", realName: "First Name"},
                {fieldName: "AUTHUSR_LASTNAME",  realName: "Last Name"},
                {fieldName: "AUTHUSR_EMAIL",     realName: "E-mail"},
                {fieldName: "AUTHUSR_LOGIN",     realName: "Login"}
         ]

        // User Role Rel properties
        const userRoleParams: IAuditField [] = [
            {fieldName: "WB_DOMITEM_ID", realName: `User Roles`,           fkMapper: esWB_Domain_Item, fkMapperNameField: "DOMAIN_ITEM_NAME", bAllMsg: true},
            {fieldName: "WB_CUST_ID",    realName: "Customer Restriction", fkMapper: esWB_Customer,    fkMapperNameField: "CUSTOMER_NAME", fkMapperIdField: "CUSTOMER_ID", bAllMsg: true }
        ]

        // User Customer Relationship properties
        const userCustomerParams: IAuditField [] = [
            {fieldName: "WB_CUST_ID", realName: "Customer", fkMapper: esWB_Customer, fkMapperNameField: "CUSTOMER_NAME", fkMapperIdField: "CUSTOMER_ID", bAllMsg: true}
        ]

        // User Dimension Default properties
        const userDimensionParams: IAuditField [] = [
            {fieldName: "WB_DIMENSION_ID",    realName: `Reporting Dimension`,  fkMapper: esWB_Dimension, fkMapperNameField: "DIMENSION_NAME", bAllMsg: true},
            {fieldName: "SELECTEDHIERARCHY",  realName: `Hierarchy Key`},
            {fieldName: "SELECTEDKEYS",       realName: `Hierarchy Node Keys`}
        ]

        // User Business Unit properties
        const userBusinessUnitParams: IAuditField [] = [
            {fieldName: "WB_BUSINESSUNIT_ID", realName: "Business Unit",        fkMapper: esWB_BusinessUnit, fkMapperNameField: "BUSINESSUNIT_NAME", bAllMsg: true}
        ]

        // User Group properties
        const userGroupParams: IAuditField [] = [
            {fieldName: "WB_USRGRP_ID",       realName: "User Group",           fkMapper: esWB_User_Group, fkMapperNameField: "USRGRP_NAME", bAllMsg: true}
        ]

        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_User,userParams, {objectName: 'User', deletedKeys: deleteKeys})

        for(let aUsrGrpRelRow of self.drWB_User.WB_UserGroupUserRows){
            await AuditUtils.logRecord(auditService, aUsrGrpRelRow, userGroupParams,{objectName: 'User Group Assignment', deletedKeys: deleteKeys})
        }


        for(let aUsrRoleRelRow of self.drWB_User.WB_UserRoleRows){
            await AuditUtils.logRecord(auditService, aUsrRoleRelRow, userRoleParams,{objectName: 'User Role Assignment', deletedKeys: deleteKeys})
        }

        for(let aUsrCustomerRelRow of self.drWB_User.WB_UserCustomerRows) {
            await AuditUtils.logRecord(auditService, aUsrCustomerRelRow, userCustomerParams, {objectName: 'Customer Assignment', deletedKeys: deleteKeys})
        }

        for(let aUsrDimRow of self.drWB_User.WB_UserDimensionRows){
            await AuditUtils.logRecord(auditService, aUsrDimRow, userDimensionParams,{objectName: 'Dimension Defaults', deletedKeys: deleteKeys})
        }

        for(let aUsrBsnUnitRow of self.drWB_User.WB_UsrBusinessUnitRows){
            await AuditUtils.logRecord(auditService, aUsrBsnUnitRow, userBusinessUnitParams,{objectName: 'Business Unit Assignment', deletedKeys: deleteKeys})
        }

        return auditService;

    }

}
